import { useQuery } from "@tanstack/react-query";
import { GET_SHIPMENT_LIST } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IShipment } from "@/types/apiResponse.types";

interface IParcelsRequest {
  data: {
    data: IShipment[];
  };
}

export const useParcelsRequest = (params?: object) => {
  return useQuery<IParcelsRequest>({
    queryKey: [GET_SHIPMENT_LIST, params],
    queryFn: () => apiRequest(GET_SHIPMENT_LIST, "get", params),
  });
};
